import { render, staticRenderFns } from "./MeusSimulados.vue?vue&type=template&id=cbb08bb4&scoped=true&"
import script from "./MeusSimulados.vue?vue&type=script&lang=js&"
export * from "./MeusSimulados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb08bb4",
  null
  
)

export default component.exports